import { Title } from "components/Title";

export const PROFILE_ADMIN = { id: 1, name: 'Admin', title :  "Administrador" };
export const PROFILE_COMPANY = { id: 2, name: 'Company', title :  "Empresas" };
export const PROFILE_EMPLOYEE = { id: 3, name: 'Employee', title : "Funcionários" };

export const roles = [
    { label: PROFILE_ADMIN.title, id: PROFILE_ADMIN.id },
    { label: PROFILE_COMPANY.title, id: PROFILE_COMPANY.id },
    { label: PROFILE_EMPLOYEE.title, id: PROFILE_EMPLOYEE.id },
];




